import ToggleButtonGroupControl, {
  Props as BaseToggleButtonGroupControlProps,
} from '@/components/Controls/ToggleButtonGroupControl';

import { useDemoContext } from './DemoContext';

type ToggleButtonGroupControlProps = Omit<
  BaseToggleButtonGroupControlProps,
  'value' | 'setValue'
>;

function DemoToggleButtonGroupControl({
  id,
  ...props
}: ToggleButtonGroupControlProps) {
  const context = useDemoContext();

  const { id: demoUnitId, state, setState } = context;
  const value = state[id];
  const htmlId = `${demoUnitId}_${id}`;

  return (
    <ToggleButtonGroupControl
      {...props}
      id={htmlId}
      value={value}
      setValue={(newValue: any) => {
        setState((state) => ({
          ...state,
          [id]: newValue,
        }));
      }}
    />
  );
}

export default DemoToggleButtonGroupControl;
